// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__3Ffch","tabs":"Tabs_tabs__262Pa","addNewTab":"Tabs_addNewTab__1Skhd","updateIndicator":"Tabs_updateIndicator__3YZz-"};